export class QonversionError {
    constructor(code, description, additionalMessage, domain) {
        this.code = code;
        this.domain = domain;
        this.description = description;
        this.additionalMessage = additionalMessage;
    }
}
//# sourceMappingURL=QonversionError.js.map